delivery_options-index
  delivery_options-table(tag-scope="delivery_options_table")
  script(type="typescript").
    this.mixin('base');
